import {
  Platform,
} from '@angular/cdk/platform';
import {
  STEPPER_GLOBAL_OPTIONS,
} from '@angular/cdk/stepper';
import {
  DOCUMENT,
} from '@angular/common';
import {
  NgModule,
  Optional,
  Provider,
} from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  MatNativeDateModule,
} from '@angular/material/core';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
} from '@angular/material/dialog';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
} from '@angular/material/tooltip';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
} from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
} from '@angular/platform-browser/animations';
import {
  ServiceWorkerModule,
} from '@angular/service-worker';
import {
  ErrorsHandlerModule,
} from '@des/services/errors-handler';
import {
  LOG_SERVER_LOGGER_CLIENT_OPTIONS,
} from '@des/services/logging';
import {
  ALTERNATIVE_OFFERS_GROUPS_STORE_NAME,
  alternativeOfferGroupsStorageSync,
} from '@des/store/alternative-offers-groups';
import {
  CANCEL_REFUND_STORE_NAME,
  cancelRefundStorageSync,
} from '@des/store/cancel-refund';
import {
  MessagesBaseStoreModule,
} from '@des/store/messages';
import {
  ORDER_STORE_NAME,
  orderStorageDeserializer,
  OrderStoreModule,
} from '@des/store/order';
import {
  ORDER_ELIGIBILITIES_STORE_NAME,
  orderEligibilitiesStorageSync,
  OrderEligibilitiesStoreModule,
} from '@des/store/order-eligibilities';
import {
  EffectsModule,
} from '@ngrx/effects';
import {
  routerReducer,
  StoreRouterConnectingModule,
} from '@ngrx/router-store';
import {
  Action,
  ActionReducer,
  createReducer,
  StoreModule,
  USER_RUNTIME_CHECKS,
} from '@ngrx/store';
import {
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import {
  EVENT_TRACK_SERVICE_CONFIGURATION,
  EventTrackService,
} from '@o3r/analytics';
import {
  API_TOKEN,
  ApiManagerModule,
} from '@o3r/apis-manager';
import {
  PlaceholderModule,
  provideCustomComponents,
} from '@o3r/components';
import {
  PlaceholderRulesEngineActionModule,
} from '@o3r/components/rules-engine';
import {
  ConfigOverrideStoreModule,
  configurationAdapter,
  ConfigurationBaseServiceModule,
  ConfigurationDevtoolsModule,
  configurationReducerFeatures,
  configurationStorageSync,
  ConfigurationStoreModule,
} from '@o3r/configuration';
import {
  ConfigurationRulesEngineActionModule,
} from '@o3r/configuration/rules-engine';
import {
  AssetPathOverrideStoreModule,
  DynamicContentModule,
  RequestParametersModule,
  RequestParametersService,
} from '@o3r/dynamic-content';
import {
  AssetRulesEngineActionModule,
} from '@o3r/dynamic-content/rules-engine';
import {
  CUSTOM_LOCALIZATION_CONFIGURATION_TOKEN,
  LocalizationDevtoolsModule,
  LocalizationModule,
  LocalizationOverrideStoreModule,
  MESSAGE_FORMAT_CONFIG,
  translateLoaderProvider,
  TranslateMessageFormatLazyCompiler,
} from '@o3r/localization';
import {
  LocalizationRulesEngineActionModule,
} from '@o3r/localization/rules-engine';
import {
  LoggerModule,
  LoggerService,
} from '@o3r/logger';
import {
  AppServerRoutingModule,
  ENVIRONMENT_CONFIG_TOKEN,
} from '@o3r/routing';
import {
  RULES_ENGINE_OPTIONS,
  RulesEngineDevtoolsModule,
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  StorageKeys,
  StorageSync,
} from '@o3r/store-sync';
import {
  AIRPORT_CITY_MAPPER_SERVICE_TOKEN,
  ANALYTICS_STORE_NAME,
  AnalyticsModule,
  AnalyticsService,
  analyticsStorageSync,
  DATA_LAKE_STORE_NAME,
  dataLakeStorageSync,
  LAZY_LOADER_SERVICE_TOKEN,
} from '@refx/analytics-core';
import {
  DigitalDataCustomWindowEventEffect,
} from '@refx/analytics-effects/custom-window-event';
import {
  AnalyticsErrorEffect,
} from '@refx/analytics-effects/error';
import {
  AnalyticsOrderEffect,
} from '@refx/analytics-effects/order';
import {
  AnalyticsWarningEffect,
} from '@refx/analytics-effects/warning';
import {
  OVERRIDE_COMPONENTS_COMMON_RUNTIME_CONFIG,
  REFX_COMPONENTS_SERVICING_RUNTIME_CONFIG_DEFAULT,
  REFX_COMPONENTS_SERVICING_RUNTIME_CONFIG_ID,
} from '@refx/servicing-common';
import {
  BOOTSTRAP_CONFIGURATION_TOKEN,
  BOT_PROTECTION_FACTORY,
  createErrorsHandlerServiceConfig,
  createRequestParametersConfig,
  CustomTranslationsLoader,
  dateFnsFormatDMY,
  DEFAULT_EXTRA_PLUGINS_BY_API,
  DefaultBotProtectionFactory,
  EXPERIMENT_ANALYTICS_INTERFACE_TOKEN,
  EXTRA_PLUGINS_BY_API_TOKEN,
  GregorianDateFnsAdapter,
  prefersReducedMotion,
  REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_DEFAULT,
  REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_ID,
  refxDialogConfig,
  refxFormFieldOptions,
  refxRippleOptions,
  refxStepperGlobalOptions,
  refxTooltipDefaultOptions,
} from '@refx/shared-common';
import {
  AppLayoutModule,
  DebugLinkPresComponent,
  FooterPresModule,
  GifSpinnerModule,
  HeaderContModule,
  LazyOutletModule,
} from '@refx/shared-components';
import {
  aggregateBootstrapConfiguration,
  AirportToCityMapperService,
  AmadeusGatewayTokenModule,
  AmadeusGatewayTokenService,
  AnalyticsUtilityModule,
  AppConfigModule,
  AppInitializationModule,
  AppInitializationService,
  DocumentTitleModule,
  DynamicLocaleModule,
  DynamicLocaleService,
  FunctionalContentOverrideRulesEngineActionModule,
  getAppLocaleFactory,
  getRulesEngineOptions,
  LazyLoaderService,
  MultiCurrencyPaymentServiceModule,
  RefXDevtoolsModule,
  SelectedDataModule,
  TagsModule,
} from '@refx/shared-services';
import {
  AppConfigStoreModule,
  BREADCRUMB_STORE_NAME,
  breadcrumbStorageSync,
  ServerMessagesEffect,
  TravelerDetailsUIStoreModule,
  UiStatusStoreModule,
} from '@refx/shared-store';
import dateFnsLocaleEnGB from 'date-fns/locale/en-GB';
import {
  createServicingApisFactory,
  getAnalyticsConfiguration,
  getDigitalTouchpointData,
  getRuntimeChecksConfig,
  SERVICING_APP_BOOTSTRAP_CONFIG_DEFAULT,
  SERVICING_SERVER_LOGGER_CLIENT_OPTIONS,
} from '../configuration/index';
import {
  initializeCustomProviders,
} from '../customization/custom-providers.empty';
import {
  initializeEntryComponents,
  registerCustomComponents,
} from '../customization/presenters-map.empty';
import {
  AnalyticsServicesEffect,
  AnalyticsUpdateUserEffect,
} from '../effects/analytics/index';
import {
  environment,
} from '../environments/environment';
import {
  AppPreferencesFactsModule,
  OrderFactsModule,
  PortalFactsModule,
  TechnicalDetailsFactsModule,
  UiStatusFactsModule,
} from '../facts/index';
import {
  PreviousUrlService,
} from '../services/index';
import {
  AppComponent,
} from './app.component';
import {
  AppRoutingModule,
} from './app.routing.module';
import {
  AppSkeletonPresComponent,
} from './shared/index';

/**
 * StorageSync wrapper to sync the state of the store with the sessionStorage or localStorage
 *
 * @param reducer
 */
export function storageSyncWrapper<T, V extends Action = Action>(reducer: ActionReducer<T, V>): ActionReducer<T, V> {
  const storedStates: StorageKeys = [
    {
      [ALTERNATIVE_OFFERS_GROUPS_STORE_NAME]: alternativeOfferGroupsStorageSync
    },
    {
      [BREADCRUMB_STORE_NAME]: breadcrumbStorageSync
    },
    {
      configuration: configurationStorageSync
    },
    {
      [ORDER_STORE_NAME]: {
        deserialize: orderStorageDeserializer
      }
    },
    {
      [CANCEL_REFUND_STORE_NAME]: cancelRefundStorageSync
    },
    {
      [ORDER_ELIGIBILITIES_STORE_NAME]: orderEligibilitiesStorageSync
    },
    {
      [ANALYTICS_STORE_NAME]: analyticsStorageSync
    },
    {
      [DATA_LAKE_STORE_NAME]: dataLakeStorageSync
    }
  ];
  return new StorageSync({
    keys: storedStates,
    rehydrate: true,
    storage: sessionStorage || localStorage
  }).localStorageSync()(reducer);
}

const rootReducers = {
  router: routerReducer
};

const metaReducers = [...(environment.ENABLE_WEBSTORAGE ? [storageSyncWrapper] : [])];

const entry = initializeEntryComponents();

const customProviders: Provider[] = initializeCustomProviders();

/**
 * Configuration reducer specific to Servicing to add default global configuration in the initial state of the configuration store
 */
function servicingConfigurationReducer() {
  const initialState = configurationAdapter.upsertMany([{
    id: REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_ID,
    ...REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_DEFAULT,
    ...OVERRIDE_COMPONENTS_COMMON_RUNTIME_CONFIG
  }, {
    id: REFX_COMPONENTS_SERVICING_RUNTIME_CONFIG_ID,
    ...REFX_COMPONENTS_SERVICING_RUNTIME_CONFIG_DEFAULT
  }], configurationAdapter.getInitialState({}));

  return createReducer(
    initialState,
    ...configurationReducerFeatures
  );
}

@NgModule({
  imports: [
    AppSkeletonPresComponent,
    AnalyticsUtilityModule,
    AssetPathOverrideStoreModule,
    AssetRulesEngineActionModule,
    ConfigurationRulesEngineActionModule,
    BrowserModule,
    BrowserAnimationsModule.withConfig({
      disableAnimations: prefersReducedMotion()
    }),
    ApiManagerModule,
    DebugLinkPresComponent,
    RequestParametersModule.forRoot(createRequestParametersConfig),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    LazyOutletModule,
    LocalizationModule.forRoot(),
    LocalizationOverrideStoreModule,
    PlaceholderModule,
    TranslateModule.forRoot({
      loader: translateLoaderProvider,
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatLazyCompiler
      }
    }),
    AppRoutingModule,
    StoreModule.forRoot(rootReducers, {
      metaReducers
    }),
    EffectsModule.forRoot([
      AnalyticsErrorEffect,
      AnalyticsOrderEffect,
      AnalyticsServicesEffect,
      AnalyticsUpdateUserEffect,
      AnalyticsWarningEffect,
      ServerMessagesEffect,
      DigitalDataCustomWindowEventEffect
    ]),
    ConfigurationStoreModule.forRoot(servicingConfigurationReducer),
    LocalizationDevtoolsModule,
    RulesEngineDevtoolsModule,
    MessagesBaseStoreModule,
    OrderStoreModule,
    AppConfigStoreModule,
    ConfigOverrideStoreModule,
    OrderEligibilitiesStoreModule,
    OrderStoreModule,
    TravelerDetailsUIStoreModule,
    StoreRouterConnectingModule.forRoot(),
    ...(environment.modules || []),
    AppServerRoutingModule.forRoot(environment),
    AppLayoutModule,
    FooterPresModule,
    HeaderContModule,
    GifSpinnerModule,
    AppConfigModule,
    AppPreferencesFactsModule,
    ConfigurationBaseServiceModule,
    AppInitializationModule,
    AmadeusGatewayTokenModule,
    AnalyticsModule.forRoot(getAnalyticsConfiguration, getDigitalTouchpointData),
    DocumentTitleModule,
    ConfigurationDevtoolsModule.instrument({
      defaultLibraryName: '@refx/shared-components'
    }),
    OrderFactsModule,
    RefXDevtoolsModule.instrument({}),
    ...entry.customComponentsModules,
    MatNativeDateModule,
    MultiCurrencyPaymentServiceModule,
    DynamicContentModule,
    PlaceholderRulesEngineActionModule,
    LocalizationRulesEngineActionModule,
    FunctionalContentOverrideRulesEngineActionModule,
    PortalFactsModule,
    RulesEngineRunnerModule.forRoot({}),
    TagsModule,
    LoggerModule,
    DynamicLocaleModule,
    TechnicalDetailsFactsModule,
    UiStatusFactsModule,
    SelectedDataModule,
    ErrorsHandlerModule.forRoot({
      factory: createErrorsHandlerServiceConfig,
      deps: [ENVIRONMENT_CONFIG_TOKEN, BOOTSTRAP_CONFIGURATION_TOKEN]
    }),
    UiStatusStoreModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    provideCustomComponents(registerCustomComponents()),
    AnalyticsService,
    PreviousUrlService,
    {
      provide: BOOTSTRAP_CONFIGURATION_TOKEN,
      useFactory: aggregateBootstrapConfiguration(SERVICING_APP_BOOTSTRAP_CONFIG_DEFAULT),
      deps: [
        DOCUMENT,
        RequestParametersService
      ]
    },
    {
      provide: TranslateLoader,
      useClass: CustomTranslationsLoader
    },
    {
      provide: BOT_PROTECTION_FACTORY,
      useClass: DefaultBotProtectionFactory
    },
    {
      provide: LOG_SERVER_LOGGER_CLIENT_OPTIONS,
      useValue: SERVICING_SERVER_LOGGER_CLIENT_OPTIONS
    },
    {
      provide: API_TOKEN,
      useFactory: createServicingApisFactory,
      deps: [
        BOOTSTRAP_CONFIGURATION_TOKEN,
        BOT_PROTECTION_FACTORY,
        EventTrackService,
        RequestParametersService,
        AppInitializationService,
        AmadeusGatewayTokenService,
        Platform,
        EXTRA_PLUGINS_BY_API_TOKEN,
        [new Optional(), LoggerService]
      ]
    },
    {
      provide: LAZY_LOADER_SERVICE_TOKEN,
      useExisting: LazyLoaderService
    },
    {
      provide: AIRPORT_CITY_MAPPER_SERVICE_TOKEN,
      useExisting: AirportToCityMapperService
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: refxDialogConfig
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: refxFormFieldOptions
    },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: refxRippleOptions
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: refxStepperGlobalOptions
    },
    {
      provide: MESSAGE_FORMAT_CONFIG,
      useValue: {
        enableCache: false,
        ignoreTag: true
      }
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: refxTooltipDefaultOptions
    },
    {
      provide: EVENT_TRACK_SERVICE_CONFIGURATION,
      useValue: {
        useBrowserApiForFirstFP: true
      }
    },
    {
      provide: CUSTOM_LOCALIZATION_CONFIGURATION_TOKEN,
      useFactory: getAppLocaleFactory(environment),
      deps: [RequestParametersService, DynamicLocaleService]
    },
    {
      provide: USER_RUNTIME_CHECKS,
      useFactory: getRuntimeChecksConfig(environment),
      deps: [DOCUMENT, RequestParametersService]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: dateFnsFormatDMY
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: dateFnsLocaleEnGB
    },
    {
      provide: DateAdapter,
      useClass: GregorianDateFnsAdapter
    },
    {
      provide: RULES_ENGINE_OPTIONS,
      useFactory: getRulesEngineOptions,
      deps: [DOCUMENT, RequestParametersService]
    },
    {
      provide: EXTRA_PLUGINS_BY_API_TOKEN,
      useValue: DEFAULT_EXTRA_PLUGINS_BY_API
    },
    {
      provide: EXPERIMENT_ANALYTICS_INTERFACE_TOKEN,
      useExisting: AnalyticsService
    },
    ...customProviders
  ]
})
export class AppModule {}
